<template>
  <div class="demo">
    <img src="./../../assets/images/payroll-sample.png" />
  </div>
</template>

<script>
export default {
  name: "Demo"
};
</script>

<style lang="scss" scoped>
.demo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
</style>